import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { webApi } from '../services/api';
import { isCanceledRequest } from '../utils/abortRequest';
import { StatusBanner } from '../components/ui';
import { StarRating } from '../components/reviews/StarRating';
import { ReviewCard } from '../components/reviews/ReviewCard';

function ReportPage() {
  const [overall, setOverall] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ac = new AbortController();
    const { signal } = ac;
    (async () => {
      try {
        setLoading(true);
        const data = await webApi.getOverallReviews({ signal });
        if (signal.aborted) return;
        setOverall(data || { averageRating: 0, list: [] });
        setError('');
      } catch (err) {
        if (signal.aborted || isCanceledRequest(err)) return;
        setError(err.message || 'Failed to load reviews');
      } finally {
        if (!signal.aborted) setLoading(false);
      }
    })();
    return () => ac.abort();
  }, []);

  const avg = Number(overall?.averageRating ?? 0);
  const list = Array.isArray(overall?.list) ? overall.list : [];

  return (
    <div className="reviews-analytics-page">
      <header className="reviews-analytics-hero">
        <h1 className="reviews-analytics-title">Reviews</h1>
      </header>

      <div className="reviews-analytics-body">
        <StatusBanner kind="error" message={error} />

        {loading ? (
          <p className="reviews-loading muted">Loading reviews...</p>
        ) : (
          <>
            <section className="reviews-overall-card" aria-labelledby="reviews-overall-heading">
              <p id="reviews-overall-heading" className="reviews-overall-label">
                Overall Rating
              </p>
              <div className="reviews-overall-row">
                <span className="reviews-overall-score" aria-hidden="true">
                  {Number.isFinite(avg) ? avg.toFixed(1) : '0.0'}
                </span>
                <span className="reviews-overall-divider" aria-hidden="true" />
                <StarRating value={avg} size="lg" />
              </div>
            </section>

            <section className="reviews-recent-block" aria-labelledby="reviews-recent-heading">
              <div className="reviews-section-head">
                <h2 id="reviews-recent-heading" className="reviews-section-title">
                  Recent Reviews
                </h2>
                <Link to="/reviews" className="reviews-view-all">
                  View All
                </Link>
              </div>

              {list.length === 0 ? (
                <p className="reviews-empty muted">No reviews yet.</p>
              ) : (
                <div className="reviews-card-list">
                  {list.map((review, idx) => (
                    <ReviewCard
                      key={`${review.createdTime || ''}-${idx}-${review.name || ''}`}
                      review={review}
                    />
                  ))}
                </div>
              )}
            </section>
          </>
        )}
      </div>
    </div>
  );
}

export default ReportPage;
